import axios from "axios";

const backendapi = axios.create({
  //baseURL: "http://localhost:1708/",
  baseURL: "https://saleswebapi.rcktechiees.com/",
  //baseURL: "https://salesapi.transcredit.com/",
});

backendapi.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default backendapi;